<template>
  <div class="service-feature-container" :style="{ marginTop: data?.title ? '50px' : '10px' }">
    <ModuleTitleView :title="data?.title || ''"></ModuleTitleView>
    <div class="service-feature-content">
      <ul>
        <li v-for="(item,index) in data.data.data" :key="index">
          <div class="service-feature-content-item">
            <div class="service-feature-content-item-icon" :style="{
              backgroundColor: Math.floor(index / 2) % 2 === 0 ? 'var(--main-color)' : 'var(--main-sub-color)', // 奇偶行背景色
              maskImage: `url(${maskImage})`,
              maskSize: 'cover',
              maskPosition: 'center',
              maskRepeat: 'no-repeat'
            }"></div>
            <p>{{ item?.content ?? '' }}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>

import ModuleTitleView from "@/components/actricle/ModuleTitleView.vue"
import maskImage from "@/assets/images/ic_select.png"

const props = defineProps({
  jsonData: Object,
})

const data = reactive(props.jsonData)


</script>

<script>
export default {
  name: 'ServiceFeatureView'
}
</script>

<style scoped lang="less">

.service-feature-container {
  width: 100%;
  overflow: hidden;

  .service-feature-content {
    padding: 0 110px;

    ul {
      display: grid;
      grid-template-columns: repeat(2, 1fr); /* 每行 2 个均分 */
      justify-content: space-between;
      gap: 16px; /* 子元素之间的间距 */
      margin: 30px 0;

      li {
        list-style: none;

        .service-feature-content-item {
          display: flex;
          align-items: center;
          padding: 8px 8px;
          background: linear-gradient(90deg, #F2F2F2 20%, #FFFFFF 100%);
          border-radius: 50px;

          .service-feature-content-item-icon {
            flex-shrink: 0; /* 防止被压缩 */
            width: 32px;
            height: 32px;
          }

          p {
            flex-grow: 1; /* 让文字占据剩余空间 */
            font-size: 16px;
            color: var(--main-color);
            letter-spacing: 1px;
            margin-left: 20px;
            display: -webkit-box; /* 必须结合 -webkit-box-orient 使用 */
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            line-clamp: 2; /* 显示的最大行数 */
            overflow: hidden; /* 隐藏溢出内容 */
          }
        }
      }
    }
  }
}

</style>
